import axios from "axios";

import { BASEURL } from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";

export function ApiFinance() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  const url = BASEURL + "finance/";
  return {
    //UNITS
    GetFinanceAccountDetail: (unitId) =>
      authAxios.get(url + "GetFinanceAccountDetail/" + unitId),
    UpdateUnitFinanceAccount: (record) =>
      authAxios.post(url + "UpdateUnitFinanceAccount", record),
    GetFinanceAccountsAndDimensions: () =>
      authAxios.get(url + "GetFinanceAccountsAndDimensions"),
    GetFinanceBankAccounts: (unitId) =>
      authAxios.get(url + "GetFinanceBankAccounts/" + unitId),
    GetFinanceSubCategories: (unitId) => {
      const parsedUnitId = parseInt(unitId);
      const uId = (!isNaN(parsedUnitId) && parsedUnitId > 0) ? parsedUnitId : 0;
      return authAxios.get(url + "GetFinanceSubCategories/" + uId);
    },
    GetFinanceSubCategoriesForUnit: (unitId, scope) =>
      authAxios.get(url + "GetFinanceSubCategoriesForUnit/" + unitId, { params: { scope } }),

    //TRANSFER
    GetCashToAmanatTransferData: (unitId) =>
      authAxios.get(url + "GetCashToAmanatTransferData/" + unitId),
    GetTransactionDetails: (transNo) =>
      authAxios.get(url + "GetTransactionDetails/" + transNo),
    TransferCashinHandtoAmanat: (record) =>
      authAxios.post(url + "TransferCashinHandtoAmanat", record),
    TransferAmanatToCashInHand: (record) =>
      authAxios.post(url + "TransferAmanatToCashInHand", record, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    EditCashinHandtoAmanat: (record) =>
      authAxios.post(url + "EditCashinHandtoAmanat", record),
    ViewTransactionAttachment: (transNo) =>
      authAxios.get(url + "ViewTransactionAttachment/" + transNo, {
        responseType: "blob",
      }),
    GetTransactionAttachments: (transNo) =>
      authAxios.get(url + "GetTransactionAttachments/" + transNo),
    ViewAttachmentByFileId: (fileId) =>
      authAxios.get(url + "ViewAttachmentByFileId/" + fileId, {
        responseType: "blob",
      }),
    GetTransferDataForNotification: (notificationId) =>
      authAxios.get(url + "GetTransferDataForNotification/" + notificationId),

    DeleteTransaction: (id) =>
      authAxios.delete(url + "DeleteTransaction/" + id),

    GetCashToAmanatTransactionsByDateAndAccount: (record) =>
      authAxios.post(
        url + "GetCashToAmanatTransactionsByDateAndAccount",
        record,
      ),
    GetInfaqTransactionsByDateAndAccount: (record) =>
      authAxios.post(url + "GetInfaqTransactionsByDateAndAccount", record),

    TransferNotificationAction: (formData) =>
      authAxios.post(url + "TransferNotificationAction", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),

    AddOtherIncome: (record) => authAxios.post(url + "AddOtherIncome", record),
    EditOtherIncome: (record) =>
      authAxios.post(url + "EditOtherIncome", record),
    AddOtherIncomeLoanFromMarkaz: (record) =>
      authAxios.post(url + "AddOtherIncomeLoanFromMarkaz", record),
    GetOtherIncomeDataForNotification: (notificationId) =>
      authAxios.get(
        url + "GetOtherIncomeDataForNotification/" + notificationId,
      ),
    RequestModificationOtherIncomeLoanFromMarkaz: (record) =>
      authAxios.post(
        url + "RequestModificationOtherIncomeLoanFromMarkaz",
        record,
      ),
    ApproveOtherIncomeLoanFromMarkaz: (record) =>
      authAxios.post(url + "ApproveOtherIncomeLoanFromMarkaz", record),
    ApproveModificationOtherIncomeLoanFromMarkaz: (record) =>
      authAxios.post(
        url + "ApproveModificationOtherIncomeLoanFromMarkaz",
        record,
      ),
    AddOtherIncomeTarbiatiCourseReimbursment: (record) =>
      authAxios.post(url + "AddOtherIncomeTarbiatiCourseReimbursment", record),
    RequestModificationOtherIncomeTarbiatiCourseReimbursment: (record) =>
      authAxios.post(
        url + "RequestModificationOtherIncomeTarbiatiCourseReimbursment",
        record,
      ),
    ApproveModificationOtherIncomeTarbiatiCourseReimbursment: (record) =>
      authAxios.post(
        url + "ApproveModificationOtherIncomeTarbiatiCourseReimbursment",
        record,
      ),
    ApproveOtherIncomeTarbiatiCourseReimbursment: (record) =>
      authAxios.post(
        url + "ApproveOtherIncomeTarbiatiCourseReimbursment",
        record,
      ),

    AddOtherIncomeHelpFromMuqamiTanzeem: (record) =>
      authAxios.post(url + "AddOtherIncomeHelpFromMuqamiTanzeem", record),
    RequestModificationOtherIncomeHelpFromMuqamiTanzeem: (record) =>
      authAxios.post(
        url + "RequestModificationOtherIncomeHelpFromMuqamiTanzeem",
        record,
      ),
    ApproveOtherIncomeHelpFromMuqamiTanzeem: (record) =>
      authAxios.post(url + "ApproveOtherIncomeHelpFromMuqamiTanzeem", record),

    ApproveModificationOtherIncomeHelpFromMuqamiTanzeem: (record) =>
      authAxios.post(
        url + "ApproveModificationOtherIncomeHelpFromMuqamiTanzeem",
        record,
      ),

    AddExpenseFromCashInHand: (record) =>
      authAxios.post(url + "AddExpenseFromCashInHand", record, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    GetHalqaShareCalculatedAmount: (unitId, date) =>
      authAxios.get(url + "GetHalqaShareCalculatedAmount/" + unitId + "/" + date),
    GetHalqaShareContext: (unitId, date) =>
      authAxios.get(url + "GetHalqaShareContext/" + unitId + "/" + date),
    GetMarkazShareContext: (unitId, date) =>
      authAxios.get(url + "GetMarkazShareContext/" + unitId + "/" + date),
    AddHalqaShareExpense: (record) =>
      authAxios.post(url + "AddHalqaShareExpense", record),
    RequestEditHalqaShare: (record) =>
      authAxios.post(url + "RequestEditHalqaShare", record),
    ApproveHalqaShareExpense: (record) =>
      authAxios.post(url + "ApproveHalqaShareExpense", record),
    GetMarkazShareCalculatedAmount: (unitId, date) =>
      authAxios.get(url + "GetMarkazShareCalculatedAmount/" + unitId + "/" + date),
    MarkazShareTransfer: (record) =>
      authAxios.post(url + "MarkazShareTransfer", record),
    MarkazShareTransferWithJustification: (formData) =>
      authAxios.post(url + "MarkazShareTransferWithJustification", formData),
    ApproveMarkazShareTransfer: (record) =>
      authAxios.post(url + "ApproveMarkazShareTransfer", record),
    RequestEditMarkazShare: (record) =>
      authAxios.post(url + "RequestEditMarkazShare", record),
    RequestEditMarkazShareWithJustification: (formData) =>
      authAxios.post(url + "RequestEditMarkazShareWithJustification", formData),
    GetMarkazShareNotificationContext: (notificationId) =>
      authAxios.get(url + "GetMarkazShareNotificationContext/" + notificationId),
    EditExpense: (record) =>
      authAxios.post(url + "EditExpense/", record, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    EditExpenseFromAmanat: (record) =>
      authAxios.post(url + "EditExpenseFromAmanat", record, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    AddExpenseFromAmanat: (record) =>
      authAxios.post(url + "AddExpenseFromAmanat", record, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    ApproveExpenseFromAmanat: (record) =>
      authAxios.post(url + "ApproveExpenseFromAmanat", record),
    ApproveEditExpenseFromAmanat: (record) =>
      authAxios.post(url + "ApproveEditExpenseFromAmanat", record),
    ApproveExpenseFromCashInHand: (record) =>
      authAxios.post(url + "ApproveExpenseFromCashInHand", record),
    GetExpenseTransactions: (record) =>
      authAxios.post(url + "GetExpenseTransactions", record),
    DeleteExpense: (id) => authAxios.delete(url + "DeleteExpense/" + id),
    GetFinanceSubCategoryAccountsByCode: (type) =>
      authAxios.get(url + "GetFinanceSubCategoryAccountsByCode/" + type),
    GetVendorBankAccounts: () =>
      authAxios.get(url + "GetVendorBankAccounts"),
    GetVendorBankAccountsByCnic: (cnic, type) =>
      authAxios.get(url + "GetVendorBankAccountsByCnic", { params: { cnic, type } }),
    AddVendorBankAccount: (record) =>
      authAxios.post(url + "AddVendorBankAccount", record),
    UpdateVendorBankAccount: (record) =>
      authAxios.put(url + "UpdateVendorBankAccount", record),
    DeleteVendorBankAccount: (id) =>
      authAxios.delete(url + "DeleteVendorBankAccount", { params: { id } }),

    GetAssetDonationLookups: (unitId) =>
      authAxios.get(url + "GetAssetDonationLookups/" + unitId),
    AddAssetDonation: (record) =>
      authAxios.post(url + "AddAssetDonation", record),
    ApproveAssetDonation: (record) =>
      authAxios.post(url + "ApproveAssetDonation", record),
    GetAssetDonationDataForNotification: (notificationId) =>
      authAxios.get(
        url + "GetAssetDonationDataForNotification/" + notificationId,
      ),
  };
}
